import React, { useMemo } from 'react';
import { Flex } from 'antd';
import { BellOutlined, MessageOutlined, MoonOutlined } from '@ant-design/icons';

import HeaderProfileDropdown from '../profile';
import HeaderQuickActions, {
  type IHeaderQuickActionItem,
} from './quick-actions';

interface UserProfileMenuProps {
  className?: string;
  roleText?: string;
  quickActions?: IHeaderQuickActionItem[];
}

const UserProfileMenu: React.FC<UserProfileMenuProps> = ({
  className,
  roleText = 'Nurse',
  quickActions,
}) => {
  const defaultQuickActions = useMemo<IHeaderQuickActionItem[]>(
    () => [
      {
        id: 'notifications',
        ariaLabel: 'View notifications',
        tooltip: 'Notifications',
        icon: <BellOutlined />,
        badge: { variant: 'dot', tone: 'critical' },
        testId: 'quick-action-notifications',
      },
      {
        id: 'messages',
        ariaLabel: 'View messages',
        tooltip: 'Messages',
        icon: <MessageOutlined />,
        badge: { variant: 'dot', tone: 'critical' },
        testId: 'quick-action-messages',
      },
      {
        id: 'theme-toggle',
        ariaLabel: 'Toggle theme',
        tooltip: 'Toggle theme',
        icon: <MoonOutlined />,
        testId: 'quick-action-theme',
      },
    ],
    [],
  );

  const quickActionItems = quickActions ?? defaultQuickActions;

  return (
    <Flex align="center" gap={24} className={className}>
      <Flex gap={12} align="center">
        <HeaderQuickActions actions={quickActionItems} />
        <HeaderProfileDropdown roleText={roleText} />
      </Flex>
    </Flex>
  );
};

export default UserProfileMenu;
